<template>
  <header class="main-header">
    <div class="header-content">
      <!-- 로고 -->
      <router-link to="/" class="logo">
        <span class="logo-text">물개</span>
      </router-link>

      <!-- 네비게이션 -->
      <nav class="nav-menu">
        <router-link
          to="/"
          class="nav-link"
          :class="{ active: $route.path === '/' }"
        >
          홈
        </router-link>
        <router-link
          to="/properties"
          class="nav-link"
          :class="{ active: $route.path.startsWith('/properties') }"
        >
          모든현장
        </router-link>
        <router-link
          to="/community"
          class="nav-link"
          :class="{ active: $route.path.startsWith('/community') }"
        >
          커뮤니티
        </router-link>
        <router-link
          to="/chat"
          class="nav-link"
          :class="{ active: $route.path === '/chat' }"
        >
          꾸우챗
        </router-link>
        <router-link
          to="/partners/intro"
          class="nav-link partners"
          :class="{ active: $route.path.startsWith('/partners') }"
        >
          파트너스센터
        </router-link>
        <router-link
          to="/mypage"
          class="nav-link"
          :class="{ active: $route.path.startsWith('/mypage') }"
        >
          마이페이지
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MainHeader'
}
</script>

<style scoped>
.main-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: white;
  border-bottom: 1px solid #e2e8f0;
}

.header-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo */
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-text {
  font-size: 24px;
  font-weight: 900;
  color: #2563eb;
  letter-spacing: -0.02em;
}

/* Navigation */
.nav-menu {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-link {
  padding: 8px 16px;
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s;
  cursor: pointer;
}

.nav-link:hover {
  color: #1e293b;
  background: #f1f5f9;
}

.nav-link.active {
  color: #2563eb;
  background: #eff6ff;
}

.nav-link.partners {
  color: #7c3aed;
}

.nav-link.partners:hover {
  background: #f5f3ff;
}

.nav-link.partners.active {
  color: #7c3aed;
  background: #f5f3ff;
}

.nav-link.disabled {
  color: #cbd5e1;
  cursor: not-allowed;
}

.nav-link.disabled:hover {
  color: #cbd5e1;
  background: transparent;
}
</style>
